/**
 * 注册全局自定义指令
 * @param app
 */
export function setupDirectives() {
  // empty
}
